import { LuUser } from "react-icons/lu";
import { FiSearch } from "react-icons/fi";
import { CiMenuKebab } from "react-icons/ci";
import { VscHistory } from "react-icons/vsc";
import { useEffect, useRef, useState } from "react";
import { IoArrowForwardOutline, IoDuplicateOutline } from "react-icons/io5";
import { TfiPencil, TfiShare } from "react-icons/tfi";
import { itemServices } from "../../APIServices/PasswordManagement/itemServices";
import { RiAlignItemLeftFill } from "react-icons/ri";
import { MdOutlineArchive, MdOutlineCategory, MdOutlineUnarchive, MdSettingsBackupRestore } from "react-icons/md";
import { Button, Col, Collapse, Container, Form, InputGroup, ListGroup, Row, Spinner } from "react-bootstrap";
import { BsActivity, BsArrowsMove, BsLayoutSidebar, BsLayoutSidebarReverse, BsShieldLock, BsSortDown } from "react-icons/bs";
import { FaPlus, FaRegStar, FaTrash, FaStar, FaArchive } from "react-icons/fa";
import { CgArrowTopRightR, CgArrowTopLeftR } from "react-icons/cg";
import Swal from "sweetalert2";
import AddNewItem from "./AddNewItem";
import UpdateItem from "./UpdateItem";
import UseToggle from "../../Hooks/UseToggle";
import ViewCardDetails from "./ViewCardDetails";
import ViewBankAccountDetails from "./ViewBankAccountDetails";
import MoveItem from "./MoveItem";
import CategoryList from "./CategoryList";
import InformationDetails from "./InformationDetails";
import UpdatedActivity from "./UpdatedActivity";
import { DataNotFound, ListLoader } from "../../Hooks/PageLoader";
import { superAdminMetaServices } from "../../APIServices/MetaManagement/superAdminMetaServices";
import { useApp } from "../../APIHelpers/AppContext";
import { decryptGroupKey, decryptItemKey, decryptPayload, decryptPrivateKey, decryptSharedKey, encryptItemKey, encryptPayload, generateNewKey, maskBankAccount, maskNumber } from "../../APIHelpers/utils";
import AdditionalDetails from "./AdditionalDetails";
import Moment from "react-moment";
import ShareList from "./ShareManagement/ShareList";
import ShareWith from "./ShareManagement/ShareWith";
import { GrOrganization } from "react-icons/gr";

const ItemManagement = ({
  activeItem,
  groupId,
  status,
  isDark,
  plateformSettings,
  selectedCategoryId,
  groupList,
  groupData,
  setUpdator,
  currentUserData,
  auth
}) => {
  const AppRef = useRef(null);
  const MoreActionRef = useRef(null);
  const toggles = UseToggle();
  const [itemList, setItemList] = useState([]);
  const [itemCatList, setItemCatList] = useState([]);
  const [itemCatCount, setItemCatCount] = useState([]);
  const [itemData, setItemData] = useState("");
  const [itemDataLoader, setItemDataLoader] = useState(false);
  const [itemId, setItemId] = useState("");
  const [itemCat, setItemCat] = useState("");
  const [itemCount, setItemCount] = useState(0);
  const [itemLoader, setItemLoader] = useState(false);
  const [itemCatLoader, setItemCatLoader] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [searchItemCatData, setSearchItemCatData] = useState("");
  const [searchItemData, setSearchItemData] = useState("");
  const [hideShow, setHideShow] = useState(false);
  const [openSort, setOpenSort] = useState(false);
  const [openCloseMenu, setOpenCloseMenu] = useState(false);
  const [moreAction, setMoreAction] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [categoryData, setCategoryData] = useState("");
  const functionSettings = plateformSettings?.settings?.functionSettings;
  const showFunctionSettings = plateformSettings?.settings?.showFunctionSettings;
  const sidebarSettings = plateformSettings?.settings?.sidebarSettings;
  const showSidebarSettings = plateformSettings?.settings?.showSidebarSettings;

  const [itemCatPageNumber, setItemCatPageNumber] = useState(1);
  const [itemsCatPerPage, setItemsCatPerPage] = useState(15);
  const startItemCatIndex = (itemCatPageNumber - 1) * itemsCatPerPage;
  const totalItemCatPage = Math.ceil(itemCatCount / itemsCatPerPage);
  const getUniqueItemList = async () => {
    setItemCatLoader(true);
    let data = await itemServices.getUniqueItemList(auth, status, groupId, categoryId, searchItemCatData, itemCatPageNumber, itemsCatPerPage)
    if (data === "AbortError") {
      setItemCatLoader(true);
    } else {
      setItemCatList(data?.data || [])
      setItemCatCount(data?.count || 0)
      setItemCatLoader(false)
    }
  }

  const [itemPageNumber, setItemPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startItemIndex = (itemPageNumber - 1) * itemsPerPage;
  const totalItemPage = Math.ceil(itemCount / itemsPerPage);

  const getItemList = async () => {
    setItemLoader(true);
    let data = await itemServices.getItemList(auth, status, groupId, itemCat?.title, searchItemData, categoryId, itemPageNumber, itemsPerPage)
    if (data === "AbortError") {
      setItemLoader(true);
    } else {
      let result = data?.data || []
      let countData = data?.count || 0
      setItemCount(countData)
      if (countData === 1) {
        setItemDataLoader(true);
        setItemId(result?.[0]?.itemId)
      } else {
        const finalData = await Promise.all(
          result.map(async (element) => {
            let itemInfo
            if (element?.itemGroupShared) {
              if (element?.sharedKey) {
                let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
                let decryptedSharedKey = await decryptSharedKey(element?.sharedKey, decryptedPrivateKey)
                let decryptedGroupKey = await decryptGroupKey(element?.groupKey, element?.groupKeyIV, decryptedSharedKey)
                let decryptedItemKey = await decryptItemKey(element?.itemKey, element?.itemKeyIV, decryptedGroupKey)
                itemInfo = await decryptPayload(element?.encryptedData, element?.encryptedDataIV, decryptedItemKey)
              } else {
                let decryptedGroupKey = await decryptGroupKey(element?.groupKey, element?.groupKeyIV, getVaultKey())
                let decryptedItemKey = await decryptItemKey(element?.itemKey, element?.itemKeyIV, decryptedGroupKey)
                itemInfo = await decryptPayload(element?.encryptedData, element?.encryptedDataIV, decryptedItemKey)
              }
            } else if (element?.sharedKey) {
              if (element?.groupKey) {
                let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
                let decryptedSharedKey = await decryptSharedKey(element?.sharedKey, decryptedPrivateKey)
                let decryptedGroupKey = await decryptGroupKey(element?.groupKey, element?.groupKeyIV, decryptedSharedKey)
                let decryptedItemKey = await decryptItemKey(element?.itemKey, element?.itemKeyIV, decryptedGroupKey)
                itemInfo = await decryptPayload(element?.encryptedData, element?.encryptedDataIV, decryptedItemKey)
              } else {
                let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
                let decryptedSharedKey = await decryptSharedKey(element?.sharedKey, decryptedPrivateKey)
                let decryptedItemKey = await decryptItemKey(element?.itemKey, element?.itemKeyIV, decryptedSharedKey)
                itemInfo = await decryptPayload(element?.encryptedData, element?.encryptedDataIV, decryptedItemKey)
              }
            } else {
              let decryptedItemKey = await decryptItemKey(element?.itemKey, element?.itemKeyIV, getVaultKey())
              itemInfo = await decryptPayload(element?.encryptedData, element?.encryptedDataIV, decryptedItemKey)
            }
            const randerValue = (name) => {
              return (itemInfo || [])?.find(item => item.name === name)
            };
            let objectData = {
              itemId: element?.itemId,
              categoryId: element?.categoryId,
              bookmark: element?.bookmark,
              updatedAt: element?.updatedAt,
            }
            if (element?.categoryId === "credentials") {
              objectData.primaryTitle = randerValue("USER_ID_EMAIL")?.label;
              objectData.primaryData = randerValue("USER_ID_EMAIL")?.value;
              objectData.secondaryTitle = randerValue("WEBSITE")?.label;
              objectData.secondaryData = randerValue("WEBSITE")?.value;
            } else if (element?.categoryId === "softwarelicense") {
              objectData.primaryTitle = randerValue("SOFTWARE_NAME")?.label;
              objectData.primaryData = randerValue("SOFTWARE_NAME")?.value;
              objectData.secondaryTitle = randerValue("SOFTWARE_VERSION")?.label;
              objectData.secondaryData = randerValue("SOFTWARE_VERSION")?.value;
            } else if (element?.categoryId === "bankaccount") {
              objectData.primaryTitle = randerValue("ACCOUNT_HOLDER_NAME")?.label;
              objectData.primaryData = randerValue("ACCOUNT_HOLDER_NAME")?.value;
              objectData.secondaryTitle = randerValue("ACCOUNT_NUMBER")?.label;
              objectData.secondaryData = maskBankAccount(randerValue("ACCOUNT_NUMBER")?.value);
            } else if (element?.categoryId === "creditcards" || element?.categoryId === "debitcards") {
              objectData.primaryTitle = randerValue("CARD_HOLDER_NAME")?.label;
              objectData.primaryData = randerValue("CARD_HOLDER_NAME")?.value;
              objectData.secondaryTitle = randerValue("CARD_NUMBER")?.label;
              objectData.secondaryData = maskNumber(randerValue("CARD_NUMBER")?.value);
            } else {
              objectData.primaryTitle = randerValue("TITLE")?.label;
              objectData.primaryData = randerValue("TITLE")?.value;
              objectData.secondaryTitle = `Confidentials`;
              objectData.secondaryData = `xxxxxxxxxxxxxx`;
            };
            return objectData
          })
        );
        setItemList(finalData)
      }
      setItemLoader(false)
    }
  }

  const { getVaultKey } = useApp();
  const getSingleItem = async (itemId) => {
    setItemDataLoader(true)
    let data = await itemServices.getSingleItem(auth, itemId)
    if (data === "AbortError") {
      setItemDataLoader(true);
    } else {
      let result = data?.data || ""
      if (result) {
        let itemInfo
        if (result?.itemGroupShared) {
          if (result?.sharedKey) {
            let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
            let decryptedSharedKey = await decryptSharedKey(result?.sharedKey, decryptedPrivateKey)
            let decryptedGroupKey = await decryptGroupKey(result?.groupKey, result?.groupKeyIV, decryptedSharedKey)
            let decryptedItemKey = await decryptItemKey(result?.itemKey, result?.itemKeyIV, decryptedGroupKey)
            itemInfo = await decryptPayload(result?.encryptedData, result?.encryptedDataIV, decryptedItemKey)
          } else {
            let decryptedGroupKey = await decryptGroupKey(result?.groupKey, result?.groupKeyIV, getVaultKey())
            let decryptedItemKey = await decryptItemKey(result?.itemKey, result?.itemKeyIV, decryptedGroupKey)
            itemInfo = await decryptPayload(result?.encryptedData, result?.encryptedDataIV, decryptedItemKey)
          }
        } else if (result?.sharedKey) {
          if (result?.groupKey) {
            let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
            let decryptedSharedKey = await decryptSharedKey(result?.sharedKey, decryptedPrivateKey)
            let decryptedGroupKey = await decryptGroupKey(result?.groupKey, result?.groupKeyIV, decryptedSharedKey)
            let decryptedItemKey = await decryptItemKey(result?.itemKey, result?.itemKeyIV, decryptedGroupKey)
            itemInfo = await decryptPayload(result?.encryptedData, result?.encryptedDataIV, decryptedItemKey)
          } else {
            let decryptedPrivateKey = await decryptPrivateKey(currentUserData?.privateKey, currentUserData?.privateKeyIV, getVaultKey())
            let decryptedSharedKey = await decryptSharedKey(result?.sharedKey, decryptedPrivateKey)
            let decryptedItemKey = await decryptItemKey(result?.itemKey, result?.itemKeyIV, decryptedSharedKey)
            itemInfo = await decryptPayload(result?.encryptedData, result?.encryptedDataIV, decryptedItemKey)
          }
        } else {
          let decryptedItemKey = await decryptItemKey(result?.itemKey, result?.itemKeyIV, getVaultKey())
          itemInfo = await decryptPayload(result?.encryptedData, result?.encryptedDataIV, decryptedItemKey)
        }
        let itemInformation = itemInfo?.filter(item => item.define === "pre")
        let additionalInformation = itemInfo?.filter(item => item.define === "post")

        let resultData = {
          adminId: result?.adminId,
          adminName: result?.adminName,
          adminRole: result?.adminRole,
          accountId: result?.accountId,
          groupId: result?.groupId,
          groupName: result?.groupName,
          categoryId: result?.categoryId,
          categoryIcon: result?.categoryIcon,
          categoryName: result?.categoryName,
          itemId: result?.itemId,
          itemInfo: itemInformation,
          metadata: result?.metadata,
          additionalInfo: additionalInformation || [],
          bookmark: result?.bookmark,
          sharedKey: result?.sharedKey,
          sharedKeyIV: result?.sharedKeyIV,
          groupKey: result?.groupKey,
          groupKeyIV: result?.groupKeyIV,
          itemKey: result?.itemKey,
          itemKeyIV: result?.itemKeyIV,
          createdAt: result?.createdAt,
          updatedAt: result?.updatedAt,
        }
        setItemData(resultData)
      } else {
        setItemData("")
      }
    }
    setItemDataLoader(false)
  }

  useEffect(() => {
    if (itemId) {
      getSingleItem(itemId)
    }
  }, [itemId]);

  const updateStatusItem = async (itemId, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} item!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.itemId = itemId;
        userData.type = type;
        let data =
          await itemServices.updateStatusItem(
            auth,
            userData
          );
        if (data?.statusCode === 200) {
          getSingleItem(itemId);
          setItemData("");
          setItemId("")
          getItemList()
        }
      }
    });
  };

  const deleteItem = async (itemId) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Permanent Delete this Item?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, permanent delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {}
        userData.itemId = itemId
        let data = await itemServices.deleteItem(auth, userData)
        if (data?.statusCode === 200) {
          getSingleItem(itemId);
          setUpdator(`itemUpdate_${Math.floor(10000 + Math.random() * 90000)}`);
          setItemData("");
          setItemId("")
          getItemList()
        }
      }
    });
  };

  const duplicateItem = async (itemData) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Duplicate this Item?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, duplicate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = { duplicate: false }
        let itemUniqueId = Math.random().toString().substr(2, 10);
        let itemInfo = [...(itemData?.itemInfo || []), ...(itemData?.additionalInfo || [])]
        let itemKey = await generateNewKey()
        if (itemData?.groupId === "personal") {
          let { encryptedItemKey, itemKeyIV } = await encryptItemKey(itemKey, getVaultKey())
          let { encryptedData, encryptedDataIV } = await encryptPayload(itemInfo, itemKey)
          userData.encryptedData = encryptedData
          userData.encryptedDataIV = encryptedDataIV
          userData.itemKeys = [
            {
              scope: "owner",
              itemId: itemUniqueId,
              groupId: "personal",
              itemKey: encryptedItemKey,
              itemKeyIV: itemKeyIV,
            },
          ];
        } else {
          let decryptedGroupKey = await decryptGroupKey(itemData?.groupKey, itemData?.groupKeyIV, getVaultKey())
          let { encryptedItemKey: encryptedItemOwnerKey, itemKeyIV: itemKeyOwnerIV } = await encryptItemKey(itemKey, getVaultKey())
          let { encryptedItemKey: encryptedItemGroupKey, itemKeyIV: itemKeyGroupIV } = await encryptItemKey(itemKey, decryptedGroupKey)
          let { encryptedData, encryptedDataIV } = await encryptPayload(itemInfo, itemKey)
          userData.encryptedData = encryptedData
          userData.encryptedDataIV = encryptedDataIV
          userData.itemKeys = [
            {
              scope: "owner",
              itemId: itemUniqueId,
              groupId: itemData?.groupId,
              itemKey: encryptedItemOwnerKey,
              itemKeyIV: itemKeyOwnerIV,
            },
            {
              scope: "group",
              itemId: itemUniqueId,
              groupId: itemData?.groupId,
              itemKey: encryptedItemGroupKey,
              itemKeyIV: itemKeyGroupIV,
            },
          ];
        }
        userData.itemId = itemUniqueId
        userData.groupId = itemData?.groupId
        userData.categoryId = itemData?.categoryId
        userData.metadata = itemData?.metadata
        let data = await itemServices.addNewItem(auth, userData)
        if (data?.statusCode === 200) {
          getItemList()
          getUniqueItemList()
        }
      }
    });
  };

  const updatedItem = async (itemUniqueId, bookmark) => {
    let userData = {}
    userData.itemId = itemUniqueId
    userData.bookmarkType = true
    userData.bookmark = bookmark
    let data = await itemServices.updatedItem(auth, userData)
    if (data?.statusCode === 200) {
      getItemList()
      if (itemId) {
        getSingleItem(itemId);
      }
      if (activeItem === "bookmark") {
        setItemData("");
        setItemId("")
      }
    }
  };

  const getCategoryMetaList = async () => {
    const res = await superAdminMetaServices.getCategoryMetaList(auth, "all");
    setCategoryList(res?.data || []);
  };

  useEffect(() => {
    if (status && groupId && itemCat) {
      getItemList()
    }
    setItemData("")
    setItemId("")
  }, [auth, status, groupId, itemCat, searchItemData, categoryId, itemPageNumber, itemsPerPage]);

  useEffect(() => {
    if (status && groupId) {
      getUniqueItemList()
    }
    setItemData("")
    setItemId("")
    setItemCat("")
  }, [auth, status, groupId, searchItemCatData, categoryId, itemCatPageNumber, itemsCatPerPage]);

  useEffect(() => {
    setIsEdit(false)
    setHideShow(false)
  }, [activeItem, itemId]);

  useEffect(() => {
    setCategoryId(selectedCategoryId)
  }, [selectedCategoryId]);

  useEffect(() => {
    setItemData("")
    setItemId("")
    setItemList([])
    setItemCount(0)
  }, [activeItem, itemCat]);

  useEffect(() => {
    getCategoryMetaList("all");
  }, [auth]);

  useEffect(() => {
    getCategoryMetaList("all");
    const handleClickOutside = (event) => {
      if (AppRef.current && !AppRef.current.contains(event.target)) {
        setOpenSort(false);
      }
      if (MoreActionRef.current && !MoreActionRef.current.contains(event.target)) {
        setMoreAction(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  let hideShowAction = (activeItem === "archived" || activeItem === "trash") ||
    ((!functionSettings?.hideShowShare && !showFunctionSettings?.hideShowShare)
      || (!functionSettings?.hideShowMove && !showFunctionSettings?.hideShowMove)
      || (!functionSettings?.hideShowDuplicate && !showFunctionSettings?.hideShowDuplicate)
      || (!functionSettings?.hideShowArchive && !showFunctionSettings?.hideShowArchive)
      || (!functionSettings?.hideShowDelete && !showFunctionSettings?.hideShowDelete)
      || (!functionSettings?.hideShowEdit && !showFunctionSettings?.hideShowEdit)
      || (!functionSettings?.hideShowShareHistory && !showFunctionSettings?.hideShowShareHistory)
      || (!functionSettings?.hideShowUpdatedActivity && !showFunctionSettings?.hideShowUpdatedActivity)
      || (!functionSettings?.hideShowPermanentDelete && !showFunctionSettings?.hideShowPermanentDelete)
      || (!sidebarSettings?.favorites && !showSidebarSettings?.favorites)
    );

  const getActiveItemLabel = () => {
    let label;
    switch (activeItem) {
      case "all":
        label = "All Item";
        break;
      case "bookmark":
        label = "Favorites";
        break;
      case "archived":
        label = "Archived";
        break;
      case "personal":
        label = "Personal";
        break;
      case "sharedWithMe":
        label = "Shared with me";
        break;
      case "sharedWithMeGroups":
        label = "Received Groups";
        break;
      case "sharedByMe":
        label = "Shared By me";
        break;
      case "sharedByMeGroups":
        label = "My Shared Groups";
        break;
      case "trash":
        label = "Trash";
        break;
      default:
        const category = categoryList?.find(item => item?.key === activeItem);
        label = category ? category.name : groupData?.groupName;
    }
    return itemCatCount >= 0 ? `${label} (${itemCatCount})` : label;
  };

  const getActiveItemIcon = (activeItem, categoryList) => {
    switch (activeItem) {
      case "all":
        return <RiAlignItemLeftFill />;
      case "bookmark":
        return <FaStar className="text-warning" />;
      case "personal":
        return <BsShieldLock />;
      case "archived":
        return <FaArchive />;
      case "sharedWithMe":
        return <CgArrowTopRightR />;
      case "sharedWithMeGroups":
        return <CgArrowTopRightR />;
      case "sharedByMe":
        return <CgArrowTopLeftR />;
      case "sharedByMeGroups":
        return <CgArrowTopLeftR />;
      case "trash":
        return <FaTrash />;
      default:
        const category = categoryList?.find(item => item?.key === activeItem);
        if (category) {
          return (
            <img
              src={category.icon}
              alt={category.name}
              width={14}
              height={14}
            />
          );
        }
        return <MdOutlineCategory />;
    }
  };

  const loadMore = () => {
    const current = itemList.length;
    setItemsPerPage(current + 10)
  };

  const handleScroll = (e) => {
    const el = e.target;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
      loadMore();
    }
  };

  return (
    <div className="position-relative">
      <div className="p-2 hstack gap-2 border-bottom">
        <InputGroup>
          <Form.Select
            className="interactive-input"
            style={{
              fontSize: 12,
              padding: "6px 15px",
              width: "20%",
              cursor: categoryId === activeItem ? "not-allowed" : "pointer"
            }}
            onChange={(e) => setCategoryId(e.target.value)}
            value={categoryId}
            disabled={categoryId === activeItem}
          >
            <option value="">All Category</option>
            {categoryList?.map((item, index) => (
              <option key={index} value={item?.key}>
                {item?.name}
              </option>
            ))}
          </Form.Select>
          <FiSearch className="position-absolute" style={{ top: 11, left: "26.5%", zIndex: 99 }} />
          <Form.Control onChange={(e) => setSearchItemCatData(e.target.value)} values={searchItemCatData} type="search" className="interactive-input py-2 ps-5" title="Search Here..." style={{ fontSize: 12, width: "70%" }} placeholder={`Search by Title...`} />
        </InputGroup>
        {!(activeItem === "bookmark" || activeItem === "trash" || activeItem === "sharedWithMe" || activeItem === "sharedWithMeGroups" || activeItem === "sharedByMe" || activeItem === "sharedByMeGroups" || activeItem === "archived") &&
          <Button className="text-nowrap hstack gap-2 btn-gradient" style={{ fontSize: 13 }} title="Add New Item" onClick={toggles.setToggle3}><FaPlus /> New Item</Button>
        }
      </div>
      <Container fluid>
        <Row>
          <Form.Group as={Col} md={openCloseMenu ? 1 : 3} className="p-0 border-end">
            <div style={{ height: "100vh" }}>
              <div className={`p-2 pb-1 hstack ${openCloseMenu ? "justify-content-center" : "justify-content-between"} gap-2`}>
                {!openCloseMenu && (
                  <Button
                    variant={isDark ? "outline-dark" : "outline-light"}
                    className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`}
                    title={getActiveItemLabel()}>
                    {getActiveItemIcon(activeItem, categoryList)} <span style={{ fontSize: 14 }}>{getActiveItemLabel()}</span>
                  </Button>
                )}
                <Button variant={isDark ? "outline-dark" : "outline-light"} ref={AppRef} onClick={() => setOpenCloseMenu(!openCloseMenu)} className={`${isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1`} title={openCloseMenu ? "Expand Sidebar" : "Collapse Sidebar"}>{openCloseMenu ? <BsLayoutSidebar /> : <BsLayoutSidebarReverse />}</Button>
              </div>
              <div className="item-panel">
                {itemCatLoader ? <ListLoader /> : itemCatCount > 0 ? (
                  <div className="item-list" onScroll={handleScroll}>
                    {itemCatList.map((item, index) => (
                      <>
                        {!openCloseMenu ? (
                          <div
                            key={index}
                            className={`item-card hstack shadow-sm ${itemCat?.title === item.title ? "active" : ""}`}
                            onClick={() => setItemCat(item)}
                            title={item.title}
                          >
                            <div className={`${isDark ? "bg-dark" : "bg-white"} rounded-circle p-2 h-100`}>
                              <img
                                src={item.icon}
                                alt=""
                                className="item-icon hstack justify-content-center"
                              />
                            </div>
                            <div className="item-content">
                              <div className="item-title">{item.title}</div>
                            </div>
                            {(!plateformSettings?.settings?.sidebarSettings?.favorites && !plateformSettings?.settings?.showSidebarSettings?.favorites)
                              && !(activeItem === "trash" || activeItem === "archived") && (
                                <div
                                  className="item-favorite"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  title={item.bookmark ? "Remove favorite" : "Add to favorite"}
                                >
                                  {item.bookmark ? (
                                    <FaStar className="text-warning" />
                                  ) : (
                                    <FaRegStar />
                                  )}
                                </div>
                              )}
                          </div>
                        ) : (
                          <div
                            key={index}
                            className={`sidebar-icon 
                              ${itemCat?.title === item.title ? "active" : ""} 
                              ${openCloseMenu ? "centered" : ""}
                            `}
                            onClick={() => { setItemCat(item); setItemLoader(true) }}
                            title={item.title}
                          >
                            <img src={item.icon} alt={item.title} />
                          </div>

                        )}
                      </>
                    ))}
                    {itemCatLoader && (
                      <div className="hstack justify-content-center gap-1 py-4">
                        <Spinner style={{ width: 10, height: 10 }} animation="grow" />
                        <Spinner style={{ width: 10, height: 10 }} animation="grow" />
                        <Spinner style={{ width: 10, height: 10 }} animation="grow" />
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="item-empty-state">
                    There are no items.
                  </div>
                )}
              </div>
            </div>
          </Form.Group>
          <Form.Group as={Col} md={openCloseMenu ? 11 : 9} className="p-0">
            <div style={{ height: "calc(100vh - 54px)" }}>
              {itemLoader ? <ListLoader /> :
                <>
                  {itemCount > 0 ? (
                    <Container fluid>
                      <Row>
                        {itemCount > 1 &&
                          <Form.Group as={Col} md={openCloseMenu ? 3 : 4} className="border-end p-0">
                            <div className="position-relative">
                              <FiSearch className="position-absolute" style={{ top: 9, left: 15, zIndex: 99 }} />
                              <Form.Control onChange={(e) => setSearchItemData(e.target.value)} values={searchItemData} type="search" className="border-0 rounded-0 border-bottom py-2 ps-5" title="Search Here..." style={{ fontSize: 12 }} placeholder={`Search here...`} />
                            </div>
                            <div className="p-2 pb-1 hstack justify-content-between gap-2">
                              <Button
                                variant={isDark ? "outline-dark" : "outline-light"}
                                className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`}
                                title={`${itemCat?.title} (${itemCount})`}>
                                <img src={itemCat?.icon} width={20} height={20} /> <span style={{ fontSize: 14 }}>
                                  {`${itemCat?.title} (${itemCount})`}
                                </span>
                              </Button>
                              <div className="position-relative">
                                <Button variant={openSort ? "primary" : isDark ? "outline-dark" : "outline-light"} ref={AppRef} onClick={() => setOpenSort(!openSort)} className={`${openSort ? "text-white" : isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1`} title="Sort items"><BsSortDown /></Button>
                                <Collapse in={openSort}>
                                  <ListGroup className="position-absolute text-nowrap shadow-sm" style={{ zIndex: 99, right: -9, top: 35, fontSize: 13 }}>
                                    <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortBy" type="radio" label="By Title" /></ListGroup.Item>
                                    <ListGroup.Item action className="py-1"><Form.Check checked className="m-0 mt-1 CP" name="sortBy" type="radio" label="Date Created" /></ListGroup.Item>
                                    <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortBy" type="radio" label="Date Modified" /></ListGroup.Item>
                                    <ListGroup.Item action className="py-1"><Form.Check className="m-0 mt-1 CP" name="sortFor" type="radio" label="Newest First" /></ListGroup.Item>
                                    <ListGroup.Item action className="py-1"><Form.Check checked className="m-0 mt-1 CP" name="sortFor" type="radio" label="Oldest First" /></ListGroup.Item>
                                  </ListGroup>
                                </Collapse>
                              </div>
                            </div>
                            <div className="px-2 text-center pb-1">
                              <Form.Label className="mb-0" style={{ fontSize: 12, color: "#94a3b8", userSelect: "none" }}>Oldest First | Date Created</Form.Label>
                            </div>
                            <aside
                              className="sidebar-container px-2 overflow-auto"
                              style={{ height: "calc(100vh - 160px)" }}
                            >
                              {itemLoader ? <ListLoader /> : (
                                <>
                                  {itemList.map((item) => (
                                    <div
                                      key={item.id}
                                      className="sidebar-list my-1 shadow-sm rounded-1"
                                      onClick={() => { setItemId(item.itemId); setItemDataLoader(true) }}
                                      style={{ cursor: "pointer" }}
                                    >
                                      <div
                                        className={`sidebar-item hstack justify-content-between ${itemId === item.itemId ? "active" : ""
                                          }`}
                                        style={{ alignItems: "flex-start" }}
                                      >
                                        <div style={{ lineHeight: 1.6 }} className="text-truncate w-100">
                                          <p className="mb-0 fw-semibold" title={item.primaryTitle}>{item.primaryData}</p>
                                          <span className={`${itemId === item.itemId ? "text-white" : "text-muted"} small d-block text-truncate`} title={item.secondaryTitle}>
                                            {item.secondaryData}
                                          </span>
                                          <span className={`${itemId === item.itemId ? "text-white" : "text-muted"} small`}>
                                            Modified DT: <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                              {item?.updatedAt}
                                            </Moment>
                                          </span>
                                        </div>
                                        {(!plateformSettings?.settings?.sidebarSettings?.favorites && !plateformSettings?.settings?.showSidebarSettings?.favorites)
                                          && !(activeItem === "trash" || activeItem === "archived") && (
                                            <div
                                              className="item-favorite"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                updatedItem(item.itemId, !item.bookmark);
                                              }}
                                              title={item.bookmark ? "Remove favorite" : "Add to favorite"}
                                            >
                                              {item.bookmark ? (
                                                <FaStar className="text-warning" />
                                              ) : (
                                                <FaRegStar />
                                              )}
                                            </div>
                                          )}
                                      </div>
                                    </div>
                                  ))}
                                </>
                              )}
                            </aside>
                          </Form.Group>
                        }
                        <Form.Group as={Col} md={itemCount > 1 ? (openCloseMenu ? 9 : 8) : 12} className="p-0" >
                          {!isEdit ? (
                            <>
                              {itemDataLoader ? <div style={{ height: "calc(100vh - 54px)" }}> <ListLoader /></div> : itemId ? (
                                <>
                                  <div className="p-2 hstack justify-content-between gap-2">
                                    <div className="hstack gap-2">
                                      <Button variant={isDark ? "outline-dark" : "outline-light"} className={`${!isDark ? "text-dark" : "text-white"} py-1 px-2 rounded-1 hstack gap-2`}>{itemData?.adminRole === "organization" ? <GrOrganization title={itemData?.adminName} /> : <LuUser title={itemData?.adminName} />} <span style={{ fontSize: 14 }} title={itemData?.adminName}>{itemData?.adminName}</span> {(activeItem === "all" || activeItem === "bookmark" || activeItem === "archived" || activeItem === "trash") && <><IoArrowForwardOutline title={itemData?.groupName} /> <span style={{ fontSize: 14 }} title={itemData?.groupName}>{itemData?.groupName}</span></>}</Button>
                                    </div>
                                    <div className="hstack gap-2">
                                      {!(activeItem === "sharedWithMe" ||
                                        activeItem === "sharedWithMeGroups" ||
                                        activeItem === "sharedByMe" ||
                                        (currentUserData?.userId !== itemData?.adminId) ||
                                        activeItem === "sharedByMeGroups") &&
                                        <>
                                          {!(activeItem === "trash" || activeItem === "archived") &&
                                            <>
                                              {(!isEdit && !plateformSettings?.settings?.functionSettings?.hideShowShare && !plateformSettings?.settings?.showFunctionSettings?.hideShowShare && currentUserData?.loginAccountId) && (
                                                <Button onClick={() => toggles.setToggle1()} variant={isDark ? "outline-dark" : "outline-light"} className={`${isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1 hstack gap-1`} style={{ fontSize: 14 }} title="Share"><TfiShare /> Share</Button>
                                              )}
                                              {(!plateformSettings?.settings?.functionSettings?.hideShowEdit && !plateformSettings?.settings?.showFunctionSettings?.hideShowEdit) &&
                                                <Button variant={isDark ? "outline-dark" : "outline-light"} className={`${isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1 hstack gap-1`} style={{ fontSize: 14 }} title="Edit" onClick={() => setIsEdit(true)}><TfiPencil /> Edit</Button>
                                              }
                                            </>
                                          }
                                          <div className="hstack gap-2 position-relative">
                                            {hideShowAction &&
                                              <Button variant={moreAction ? "primary" : isDark ? "outline-dark" : "outline-light"} ref={MoreActionRef} onClick={() => setMoreAction(!moreAction)} className={`${moreAction ? "text-white" : isDark ? "text-white border" : "text-dark"} py-1 px-2 rounded-1 hstack gap-1`} style={{ fontSize: 14 }} title="More Action"><CiMenuKebab /> Action</Button>
                                            }
                                            <Collapse in={moreAction}>
                                              <ListGroup className="position-absolute text-nowrap shadow-sm" style={{ zIndex: 99, right: 0, top: 32, fontSize: 13 }}>
                                                {!(activeItem === "trash" || activeItem === "archived") &&
                                                  <>
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowEdit && !plateformSettings?.settings?.showFunctionSettings?.hideShowEdit) &&
                                                      <ListGroup.Item action className="hstack gap-2" title="Edit" onClick={() => setIsEdit(true)}><TfiPencil /> Edit</ListGroup.Item>
                                                    }
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowMove && !plateformSettings?.settings?.showFunctionSettings?.hideShowMove && currentUserData?.loginAccountId) &&
                                                      <ListGroup.Item action className="hstack gap-2" title="Move" onClick={() => toggles.setToggle2()}><BsArrowsMove /> Move</ListGroup.Item>
                                                    }
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowShare && !plateformSettings?.settings?.showFunctionSettings?.hideShowShare && currentUserData?.loginAccountId) &&
                                                      <ListGroup.Item action className="hstack gap-2" title="Share" onClick={() => toggles.setToggle1()}><TfiShare /> Share</ListGroup.Item>
                                                    }
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowDuplicate && !plateformSettings?.settings?.showFunctionSettings?.hideShowDuplicate) &&
                                                      <ListGroup.Item action className="hstack gap-2" title="Duplicate" onClick={() => duplicateItem(itemData)}><IoDuplicateOutline /> Duplicate</ListGroup.Item>
                                                    }
                                                    {(!plateformSettings?.settings?.sidebarSettings?.favorites && !plateformSettings?.settings?.showSidebarSettings?.favorites) &&
                                                      <>
                                                        {itemData?.bookmark ? (
                                                          <ListGroup.Item action className="hstack gap-2" title="Remove from Favorite" onClick={() => updatedItem(itemData?.itemId, false)}><FaStar className="text-warning" /> Remove from Favorite</ListGroup.Item>
                                                        ) : (!plateformSettings?.settings?.sidebarSettings?.favorites && !plateformSettings?.settings?.showSidebarSettings?.favorites) && (
                                                          <ListGroup.Item action className="hstack gap-2" title="Add to Favorite" onClick={() => updatedItem(itemData?.itemId, true)}><FaRegStar /> Add to Favorite</ListGroup.Item>
                                                        )}
                                                      </>
                                                    }
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowShare && !plateformSettings?.settings?.showFunctionSettings?.hideShowShare && !plateformSettings?.settings?.functionSettings?.hideShowShareHistory && !plateformSettings?.settings?.showFunctionSettings?.hideShowShareHistory && currentUserData?.loginAccountId) &&
                                                      <ListGroup.Item action className="hstack gap-2" title="Share List" onClick={() => toggles.setToggle4()}><VscHistory /> Share List</ListGroup.Item>
                                                    }
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowUpdatedActivity && !plateformSettings?.settings?.showFunctionSettings?.hideShowUpdatedActivity) &&
                                                      <ListGroup.Item action className="hstack gap-2" title="Activities" onClick={() => toggles.setToggle5()}><BsActivity /> Activities</ListGroup.Item>
                                                    }
                                                  </>
                                                }
                                                {itemData?.status === "archived" ?
                                                  <ListGroup.Item action className="hstack gap-2" title="Unarchive" onClick={() => updateStatusItem(itemData?.itemId, "unarchive")}><MdOutlineUnarchive /> Unarchive</ListGroup.Item>
                                                  : (itemData?.status === "active" && (!plateformSettings?.settings?.functionSettings?.hideShowArchive && !plateformSettings?.settings?.showFunctionSettings?.hideShowArchive)) &&
                                                  <ListGroup.Item action className="hstack gap-2" title="Archive" onClick={() => updateStatusItem(itemData?.itemId, "archive")}><MdOutlineArchive /> Archive</ListGroup.Item>
                                                }
                                                {itemData?.status === "deleted" ?
                                                  <>
                                                    <ListGroup.Item action className="hstack gap-2 text-success" title="Delete" onClick={() => updateStatusItem(itemData?.itemId, "restore")}><MdSettingsBackupRestore /> Restore</ListGroup.Item>
                                                    {(!plateformSettings?.settings?.functionSettings?.hideShowArchive && !plateformSettings?.settings?.showFunctionSettings?.hideShowArchive) &&
                                                      <ListGroup.Item action className="hstack gap-2 text-danger" title="Delete" onClick={() => deleteItem(itemData?.itemId)}><FaTrash /> Permanent Delete</ListGroup.Item>
                                                    }
                                                  </>
                                                  : (!plateformSettings?.settings?.functionSettings?.hideShowPermanentDelete && !plateformSettings?.settings?.showFunctionSettings?.hideShowPermanentDelete) &&
                                                  <ListGroup.Item action className="hstack gap-2 text-danger" title="Delete" onClick={() => updateStatusItem(itemData?.itemId, "delete")}><FaTrash /> Delete</ListGroup.Item>
                                                }
                                              </ListGroup>
                                            </Collapse>
                                          </div>
                                        </>
                                      }
                                    </div>
                                  </div>
                                  <div className="overflow-auto pt-3" style={{ height: "calc(100vh - 100px)" }}>
                                    <div className={`${openCloseMenu && itemCount === 1 ? "w-40" : openCloseMenu || itemCount === 1 ? "w-50" : "w-75"} m-auto`}>
                                      {(itemData?.categoryId === "creditcards" || itemData?.categoryId === "debitcards") ?
                                        <ViewCardDetails
                                          itemData={itemData}
                                          activeItem={activeItem}
                                          hideShow={hideShow}
                                          setHideShow={setHideShow}
                                          auth={auth}
                                          plateformSettings={plateformSettings}
                                        />
                                        : (itemData?.categoryId === "bankaccount") ?
                                          <ViewBankAccountDetails
                                            itemData={itemData}
                                            hideShow={hideShow}
                                            setHideShow={setHideShow}
                                            activeItem={activeItem}
                                            auth={auth}
                                            plateformSettings={plateformSettings}
                                          />
                                          :
                                          <>
                                            <InformationDetails
                                              itemData={itemData}
                                              activeItem={activeItem}
                                              plateformSettings={plateformSettings}
                                            />
                                            <AdditionalDetails
                                              itemData={itemData}
                                              activeItem={activeItem}
                                              plateformSettings={plateformSettings}
                                            />
                                          </>
                                      }
                                    </div>
                                  </div>
                                </>
                              ) : (
                                <div style={{ height: "calc(100vh - 54px)" }}>
                                  <DataNotFound msg={`There are no Item.`} />
                                </div>
                              )}
                            </>
                          ) : (
                            <UpdateItem
                              isDark={isDark}
                              getItemList={getItemList}
                              getSingleItem={getSingleItem}
                              setIsEdit={setIsEdit}
                              status={status}
                              itemData={itemData}
                              activeItem={activeItem}
                              auth={auth}
                              openCloseMenu={openCloseMenu}
                              itemCount={itemCount}
                              getUniqueItemList={getUniqueItemList}
                            />
                          )}
                        </Form.Group>
                      </Row>
                    </Container>
                  ) : (
                    <DataNotFound msg={`There are no Item.`} />
                  )}
                </>
              }
            </div>
          </Form.Group>
        </Row>
      </Container>
      <AddNewItem
        auth={auth}
        isDark={isDark}
        categoryData={categoryData}
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        getItemList={getItemList}
        groupId={groupId}
        groupList={groupList}
        status={status}
        activeItem={activeItem}
        currentUserData={currentUserData}
        setUpdator={setUpdator}
        getUniqueItemList={getUniqueItemList}
      />
      <ShareWith
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        Title="Share"
        itemData={itemData}
        isDark={isDark}
        currentUserData={currentUserData}
        auth={auth}
      />
      <MoveItem
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title="Move Item"
        getSingleItem={getSingleItem}
        itemData={itemData}
        getItemList={getItemList}
        setItemData={setItemData}
        setItemId={setItemId}
        activeItem={activeItem}
        isDark={isDark}
        groupList={groupList}
        auth={auth}
      />
      <CategoryList
        Show={!toggles.toggle3}
        Hide={toggles.setToggle3}
        Title="Select Category"
        categoryList={categoryList}
        isDark={isDark}
        toggles={toggles}
        setCategoryData={setCategoryData}
      />
      <ShareList
        isDark={isDark}
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        Title="Share History"
        itemData={itemData}
        auth={auth}
      />
      <UpdatedActivity
        isDark={isDark}
        Show={!toggles.toggle5}
        Hide={toggles.setToggle5}
        Title="Activities"
        itemData={itemData}
        auth={auth}
      />
    </div>
  );
};

export default ItemManagement;
